import React from 'react'
import { ReactComponent as RadioUnchecked } from '../../../../assets/svg/RadioUnchecked.svg'
import { ReactComponent as RadioChecked } from '../../../../assets/svg/RadioChecked.svg'
import { useTranslation } from 'react-i18next'

const RadioOptions = ({ options, value, onClick }) => {
    const { t } = useTranslation()
    return (
        <div>
            {options.map((option, index) => {
                return (
                    <div
                        key={index}
                        onClick={() => onClick(option)}
                        className={`flex flex-row items-center hover:cursor-pointer ml-[8px] gap-[8px] h-[20px] ${index !== 0 ? 'mt-[20px]' : ''}`}
                    >
                        <div className="h-[16px] w-[32px] flex items-start justify-center ">
                            {value === option ? <RadioChecked height={16} width={16} /> : <RadioUnchecked height={16} width={16} />}
                        </div>
                        <div className="flex flex-row items-center h-full">
                            <p className="font-bold text-[14px] leading-5 text-darkenPurple">{option}</p>
                            <div>&nbsp;</div>
                            <p className="font-bold text-[14px] leading-5 text-darkenPurple">{t('in a row')}</p>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default RadioOptions
